import React, { useEffect, useState } from "react";
import { Stack, Text, Shimmer } from "sprint-common-web";

import { GetDeliveryResponse } from "../../api/delivery-api/GetDeliveryResponse";
import { useDeliveryApi } from "../../api/delivery-api/useDeliveryApi";
import { DeliveryType } from "../../types/DeliveryType";
import { ArchiveDeliveryInfoAsideContent } from "./archive-delivery-info/ArchiveDeliveryInfoAsideContent";
import { AsperaDeliveryInfoAsideContent } from "./aspera-delivery-info/AsperaDeliveryInfoAsideContent";
import { BucketDeliveryInfoAsideContent } from "./bucket-delivery-info/BucketDeliveryInfoAsideContent";
import { DeliveryItem, mapToDeliveryItem } from "./DeliveryItem";
import { UploadDeliveryInfoAsideContent } from "./upload-delivery-info/UploadDeliveryInfoAsideContent";

export interface DeliveryInfoAsideContentProps {
    deliveryId: string;
}

export const DeliveryInfoAsideContent: React.FunctionComponent<DeliveryInfoAsideContentProps> = (
    props: DeliveryInfoAsideContentProps
) => {
    const { deliveryId } = props;

    const { getDelivery } = useDeliveryApi();

    const [delivery, setDelivery] = useState<DeliveryItem>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        getDelivery(deliveryId)
            .then((response: GetDeliveryResponse) => {
                const mappedDelivery = mapToDeliveryItem(response.delivery);

                setDelivery(mappedDelivery);
            })
            .finally(() => setIsLoading(false));
    }, [deliveryId]);

    if (isLoading) {
        return (
            <Stack styles={{ root: { paddingTop: 20 } }} tokens={{ childrenGap: "l1" }}>
                <Shimmer width="30%" />
                <Shimmer width="50%" />
                <Shimmer width="30%" />
                <Shimmer width="50%" />
                <Shimmer width="30%" />
                <Shimmer width="50%" />
            </Stack>
        );
    }

    switch (delivery?.type) {
        case DeliveryType.Aspera: {
            return <AsperaDeliveryInfoAsideContent delivery={delivery} />;
        }

        case DeliveryType.Upload: {
            return <UploadDeliveryInfoAsideContent delivery={delivery} />;
        }

        case DeliveryType.DeliveryBucket: {
            return <BucketDeliveryInfoAsideContent delivery={delivery} />;
        }

        case DeliveryType.Archive: {
            return <ArchiveDeliveryInfoAsideContent delivery={delivery} />;
        }

        case undefined: {
            return (
                <Stack styles={{ root: { margin: 20 } }}>
                    <Text>Could not load requested data</Text>
                </Stack>
            );
        }

        default:
            throw new Error("Incorrect delivery type.");
    }
};
